// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fe6Z","newExpiryDate":"styles_newExpiryDate__3vGWz","footer":"styles_footer__1ZGKu"};